import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GLOBAL } from './global';
@Injectable({
  providedIn: 'root'
})
export class CarritoService {

  headers = {
    "Accept": "application/json",
    "Content-Type": "application/json"
  };

  constructor(
    private http: HttpClient
  ) { }

  headersJson = {
    "Accept": "application/json",
    "Content-Type": "application/json"
  };

  getDatosCarrito(carrito: any): Observable<any> {
    const json = JSON.stringify(carrito);

    const params = json;
    return this.http.post(GLOBAL.urlApi+ 'carrito/getDatos', params, {headers: this.headersJson});
  }

  
}
